"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Duplicate = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 40 40"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.gray,
  d: "M34.118 30.588c3.238 0 5.882-2.644 5.882-5.882V5.882C40 2.644 37.356 0 34.118 0H15.294c-3.238 0-5.882 2.644-5.882 5.882v18.824c0 3.238 2.644 5.882 5.882 5.882zm0-2.353H15.294a3.496 3.496 0 01-3.53-3.53V5.883a3.496 3.496 0 013.53-3.53h18.824a3.496 3.496 0 013.53 3.53v18.824a3.496 3.496 0 01-3.53 3.53z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.gray,
  d: "M24.706 40c3.238 0 5.882-2.644 5.882-5.882V15.294c0-3.238-2.644-5.882-5.882-5.882H5.882C2.644 9.412 0 12.056 0 15.294v18.824C0 37.356 2.644 40 5.882 40zm0-2.353H5.882a3.496 3.496 0 01-3.53-3.53V15.295a3.496 3.496 0 013.53-3.53h18.824a3.496 3.496 0 013.53 3.53v18.824a3.496 3.496 0 01-3.53 3.53z"
}));

var _default = Duplicate;
exports.default = _default;